<div #mapContent class="mapContent"></div>
<ins-dynamic-placemark></ins-dynamic-placemark>
<ins-checklist-placemark-balloon></ins-checklist-placemark-balloon>
<ins-multiple-placemarks-menu></ins-multiple-placemarks-menu>
<ins-multiple-sites-menu></ins-multiple-sites-menu>
<div class="mapTypeSelector">
    <ins-selection-box id="selectMapType" class="componentInDialog" [options]="mapTypes"  [(value)]="selectedMapType" [label]="'Map Type'" (valueChange)="changeMapType($event)"></ins-selection-box>
</div>